import { io, Socket } from "socket.io-client";
import { talkvitConfig } from "../../../../api/talkvitAPI";

/**
 * Create (and connect) a socket.io client for the WhatsApp feature.
 * The handshake sends the user_uuid so the backend can scope events.
 */
export const initializeWhatsAppSocket = (userUuid: string): Socket => {
  const socket = io(talkvitConfig.socketUrl, {
    autoConnect: false,
    auth: {
      user_uuid: userUuid,
    },
  });
  socket.connect();
  return socket;
};
